import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthUtils } from '@app/authentication/auth.utils';
import { AuthenticationSandbox } from '@app/authentication/sandboxes/authentication.sandbox';
import { MoverRole } from '@app/move/enums/mover-role.enum';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { Navigation } from '@app/navigation/enums/navigation.enum';
import { combineLatest, map, Observable } from 'rxjs';

export function DashboardV2AllowedRolesGuard(...roles: MoverRole[]): CanActivateFn {
    return (): Observable<true | UrlTree> => {
        const authenticationSandbox = inject(AuthenticationSandbox);
        const moveSandbox = inject(MoveSandbox);
        const router = inject(Router);

        return combineLatest([authenticationSandbox.authorization$, moveSandbox.move$]).pipe(
            map(([authUser, move]): true => {
                if (AuthUtils.isMover(authUser) && roles.includes(move?.user?.role)) return true;
                void router.navigateByUrl(`/${AuthUtils.isRealEstateAgent(authUser) ? Navigation.RealEstateAgent : Navigation.Dashboard}`);
                return true;
            }),
        );
    };
}
